<template>
  <div :class="'comm-rank py-6 ' + ($vuetify.breakpoint.smAndUp ? 'px-8' : 'px-6')">
    <v-container class="pa-0 mb-6">
      <v-row class="mx-0 mb-2">
        <v-col class="pa-0" :cols="showFilter ? 8 : 12">
          <p class="title mb-0">{{title}}</p>
        </v-col>
        <v-col class="pa-0"
               :cols="showFilter ? 3 : 12"
               v-if="showFilter"
               offset="1"
               align="right">
          <v-select :items="filterOptions" value="today" hide-details class="mt-0 pt-0 pl-5" dense
                    background-color="transparent" solo
                    style="box-shadow: none !important; height: 25px; width: 120px"/>
        </v-col>
      </v-row>
      <v-row class="mx-0">
        <p class="sub-title mb-0">Mit welchem Modell arbeiten andere finUser</p>
      </v-row>

      <v-row class="mx-0 mt-5 mb-4"
             :key="index"
             v-for="(item, index) in rankElements">
        <v-col align-self="center" class="pa-0" cols="3">
          <v-avatar
            :height="$vuetify.breakpoint.mdAndUp ? iconSize : $vuetify.breakpoint.sm ? iconSmallMedium : iconSizeSmall"
            :width="$vuetify.breakpoint.mdAndUp ? iconSize : $vuetify.breakpoint.sm ? iconSmallMedium : iconSizeSmall"
            :min-width="$vuetify.breakpoint.mdAndUp ? iconSize : $vuetify.breakpoint.sm ? iconSmallMedium : iconSizeSmall"
            class="mr-3"
            color="fin-color-accent-green">
            <span class="partCount">{{ item.nr }}</span>
          </v-avatar>
        </v-col>
        <v-col align-self="center" class="pa-0 pl-md-2 pb-0" cols="6">
          {{ item.title }}
        </v-col>
        <v-col align-self="center"
               class="pa-0"
               align="right"
               cols="3">
          <v-icon class="mr-2">icon-followers</v-icon>
          {{ item.userCount }}
        </v-col>
      </v-row>

      <v-divider class="mt-6 mb-5" v-if="showMore"/>

      <v-row class="mx-0" v-if="showMore">
        <v-col cols="12" align="right" class="pa-0">
          <router-link :to="moreLink" class="more">
            Mehr anzeigen
            <v-icon size="16px">icon-arrow-link</v-icon>
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'fin-community-ranking',
  data () {
    return {
      iconSize: 48,
        iconSmallMedium: 42,
        iconSizeSmall: 38,
      filterOptions: [
        {
          text: 'Heute',
          value: 'today'
        }
      ]
    }
  },
  props: {
    rankElements: { type: Array },
    moreLink: { type: String, default: '#' },
    showMore: { type: Boolean },
    showFilter: { type: Boolean },
    title: { type: String, default: 'Community Ranking' }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../styles/variables";

  .comm-rank {
    background-color: #f7f7f7;
  }

  .title {
    font-family: $body-font-family;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: $fin-color-primary-dark;
  }

  .sub-title {
    font-family: $body-font-family;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    color: $fin-color-primary-dark;
  }

  .more {
    font-family: $body-font-family;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: 0.4px;
    text-align: center;
    color: $fin-color-primary-dark;
    /* additional styling */
    text-decoration: none;
  }

  ::v-deep {
    .v-select {
      .v-icon,
      .v-label,
      .v-select__selection {
        color: $fin-color-primary-dark;
      }

      .v-input__slot {
        box-shadow: none !important;
        margin: auto !important;
        padding-right: 0 !important;
      }
    }
  }
</style>
